import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/configuracoes/lojas/router/routes'
import usuarios from '@/domains/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/configuracoes/grupos_usuarios/router/routes'
import usuariosLogs from '@/domains/relatorios/usuarios_logs/router/routes'
import permissoes from '@/domains/configuracoes/permissoes/router/routes'
import ajuda from '@/domains/auxiliares/ajuda/router/routes'
import videosTutoriais from '@/domains/auxiliares/videos_tutoriais/router/routes'
import backupDados from '@/domains/configuracoes/backup_dados/router/routes'
import planos from '@/domains/configuracoes/planos/router/routes'
import router from '@/shared/router'
import routes from './routes'

routes.push(...formataRotasGlobais('parceiro', lojas))
routes.push(...formataRotasGlobais('parceiro', usuarios))
routes.push(...formataRotasGlobais('parceiro', usuariosLogs))
routes.push(...formataRotasGlobais('parceiro', gruposUsuarios))
routes.push(...formataRotasGlobais('parceiro', permissoes))
routes.push(...formataRotasGlobais('parceiro', ajuda))
routes.push(...formataRotasGlobais('parceiro', videosTutoriais))
routes.push(...formataRotasGlobais('parceiro', backupDados))
routes.push(...formataRotasGlobais('parceiro', planos))

router.addRoutes(routes)
export default router
